import { JSONCensusEquipment } from "../../data/models/JSONCensusEquipment";
import { getFormattedDate } from "../../../../../ReadAndWrite/ReadAndWrite/utils";
import { EquipmentListElement } from "./types";
import { EQ_TABLES_INDEXES, EQ_TABLES_NAMES } from "../../types";
import * as React from "react";
import { DeleteButton } from "../../components/DeleteButton";
import { JSONCensus } from "../../data/models/JSONCensus";
import { Column } from "react-table";

const valueOrDefault = (value: string | undefined): string => value ?? "-";

export const createDatasource = (
	list: JSONCensusEquipment[],
	removeAction: (
		jsonCensusEquipment: JSONCensusEquipment,
	) => Promise<JSONCensus>,
	refreshEquipmentList: () => Promise<void>,
): EquipmentListElement[] => {
	return list?.map((jsonCensusEquipment: JSONCensusEquipment) => {
		const equipment = jsonCensusEquipment.equipmentInfo;
		const eq: EquipmentListElement = {
			code: valueOrDefault(equipment?.code),
			name: valueOrDefault(equipment?.name),
			model: valueOrDefault(equipment?.model),
			location: valueOrDefault(equipment.location),
			since: valueOrDefault(
				getFormattedDate({ dateToFormat: equipment?.since }),
			),
			remove: (
				<DeleteButton
					jsonCensusEquipment={jsonCensusEquipment}
					removeAction={() => removeAction(jsonCensusEquipment)}
					refreshEquipmentList={refreshEquipmentList}
				/>
			),
		};
		return eq;
	});
};

const compareColumnElements = (
	elementA: EquipmentListElement,
	elementB: EquipmentListElement,
	index: string,
) => elementA[index].localeCompare(elementB[index] as string);

const createColumnElement = (
	title: string | EQ_TABLES_NAMES,
	dataIndex: string,
): Column<any> => {
	return { Header: title, accessor: dataIndex };
};

export const createColumnsList = (
	getTableHeadersName: (name: EQ_TABLES_NAMES) => string,
): readonly Column<any>[] => {
	return [
		createColumnElement(
			getTableHeadersName(EQ_TABLES_NAMES.NAME),
			EQ_TABLES_INDEXES.NAME,
		),
		createColumnElement(
			getTableHeadersName(EQ_TABLES_NAMES.CODE),
			EQ_TABLES_INDEXES.CODE,
		),
		createColumnElement(
			getTableHeadersName(EQ_TABLES_NAMES.MODEL),
			EQ_TABLES_INDEXES.MODEL,
		),
		createColumnElement(
			getTableHeadersName(EQ_TABLES_NAMES.LOCATION),
			EQ_TABLES_INDEXES.LOCATION,
		),
		createColumnElement(
			getTableHeadersName(EQ_TABLES_NAMES.SINCE),
			EQ_TABLES_INDEXES.SINCE,
		),
		createColumnElement(
			getTableHeadersName(EQ_TABLES_NAMES.REMOVE),
			EQ_TABLES_INDEXES.REMOVE,
		),
	];
};
